<script setup lang="ts">
import type {
  JournalListItemDTO,
  JournalPublisherDTO,
} from '~/shared/api/client/journals/journals.dto';
import JournalCardsGrid from './JournalCardsGrid.vue';

/**
 * The "Вам может быть интересно" block — the same publisher on "Книга" and on
 * "Реклама" (ADR 0001, decision 10). Its cards are picked by hand, so there is
 * no "Загрузить еще" under them: the set is whatever the editor put there
 */
const props = defineProps<{
  block: JournalPublisherDTO;
}>();

/**
 * A card may carry a title and a cover of its own; empty slots fall back to the
 * issue. The link is untouched either way — an override changes the face of the
 * card, not what it opens
 */
const issues = computed<JournalListItemDTO[]>(() =>
  props.block.publisher_news.flatMap((card) =>
    card.journal
      ? [
          {
            ...card.journal,
            title: card.title || card.journal.title,
            cover: card.image_one ?? card.journal.cover,
          },
        ]
      : [],
  ),
);
</script>

<template>
  <section v-if="issues.length" :class="$style.root">
    <!--
      Fixed by the design, like "Другие выпуски" over the grid of a listing tab.
      It used to be drawn from the block's title_block, which made a heading the
      layout never varies depend on a field nobody fills — the imported block has
      it empty, so the grid came out headless
    -->
    <h2 :class="$style.heading">Вам может быть интересно</h2>
    <JournalCardsGrid :issues="issues" />
  </section>
</template>

<style module lang="scss">
.root {
  display: flex;
  flex-direction: column;
  padding-bottom: var(--space-3x);
}

// The same heading the listing draws over "Другие выпуски"
.heading {
  @include text_h2;
  color: var(--color-black-1);
  margin: 0;
  padding: var(--space-3x) var(--space-2-5x);
  text-align: center;
}

@media (max-width: 767px) {
  .heading {
    @include text_h2_mobile;
  }
}
</style>
